'use client';

import { useRef } from 'react';
import styled from 'styled-components';
import Text from '@/components/common/Text';
import ScrollActive from '@/components/common/ScrollActive';

const FaqTitleStyle = styled.div`
    width: 100%;
    max-width: 1026px;
    margin: 48px auto 32px; /* similar to blog title spacing */
    padding: 0 32px;
    text-align: center;
    .faq-title-text {
        text-transform: uppercase;
        font-size: 60px;
        font-weight: 700;
        color: #111111;
        letter-spacing: 1px;
    }

    @media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) {
        padding: 0 16px;
        margin: 32px auto 24px;
        font-size: 60px;

        .faq-title-text {
            font-size: 60px;
        }
    }
`;

export default function FaqTitle({ children }) {
  const titleRef = useRef();

  return (
    <FaqTitleStyle>
      <div className="faq-title-text">
        <ScrollActive
          animTitle
          allRefs={titleRef}
          typeWordLines={`lines`}>
          <Text 
          tag={'h2'}
          className={'h2 font-montserrat faq-title-text opacity-0'}
            ref={titleRef}
            text={children} 
          />
        </ScrollActive>
      </div>
    </FaqTitleStyle>
  );
}
